import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DirectoryBase from '../CreateDirectory/DirectoryBase';
import { fetchOpportunitiesThunk, deleteOpportunityThunk, selectOpportunities, selectOpportunityLoading, selectOpportunityTotal, selectLastUpdated, selectOpportunityTags, selectDropdownOptions, } from '../../redux/opportunitySlice';
import UploadDirectoryDrawer from '../CreateDirectory/components/UploadDirectoryDrawer';
import AddNewPartnerDrawer from './components/AddNewPartnerDrawer';
import exportPartnerDirectory from './exportPartnerDirectory';
import { getCreatorDirectoryRenderers } from '../CreateDirectory/components/DirectoryCells';
const CONFIG = {
    MODULE_KEY: 'partner_directory',
    ITEMS_PER_PAGE: 20,
    ICONS: {
        category: '/assets/widgetadd.svg',
        tag: '/assets/tag.svg',
        type: '/assets/bill.svg',
    },
};
const TYPE_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'platform_tool', label: 'Platform/Tool' },
    { value: 'publisher', label: 'Publisher' },
    { value: 'subnetwork', label: 'Subnetwork' },
    { value: 'coupon_loyalty', label: 'Coupon/Loyalty' },
];
const COLUMNS = [
    { id: 'category', label: 'Category', minWidth: 130, sortable: true, draggable: false },
    { id: 'type', label: 'Type', minWidth: 100, sortable: true },
    { id: 'partners', label: 'Partner', minWidth: 200, sortable: false },
    { id: 'stats', label: 'Traffic', minWidth: 100, sortable: true },
    { id: 'contact_name', label: 'Contact Name', minWidth: 150, sortable: true },
    { id: 'contact_title', label: 'Contact Title', minWidth: 150, sortable: true },
    { id: 'tags', label: 'Tags', minWidth: 180, sortable: true },
    { id: 'primary_lead_name', label: 'Primary Lead', minWidth: 150, sortable: true },
    { id: 'date_added', label: 'Date Added', minWidth: 130, sortable: true },
    { id: 'action', label: 'Action', minWidth: 120, sortable: false, draggable: false },
];
const PartnerDirectory = () => {
    const dispatch = useDispatch();
    const dropdownOptions = useSelector(selectDropdownOptions);
    const tags = useSelector(selectOpportunityTags);
    const renderCell = useCallback((row, column, onEdit, onSuccess) => {
        const renderers = getCreatorDirectoryRenderers(row, onEdit, onSuccess, dispatch);
        const wrap = (node) => (_jsx("div", { className: "all-Font-Sizes", style: { textTransform: 'capitalize', color: '#344054', fontSize: '14px' }, children: node }));
        return renderers[column.id]?.() ?? wrap(row[column.id] || '-');
    }, [dispatch]);
    const filtersConfig = useMemo(() => [
        {
            key: 'category',
            icon: CONFIG.ICONS.category,
            label: 'Category',
            options: [{ value: 'all', label: 'All' }, ...(dropdownOptions?.map((c) => ({ value: c.value, label: c.label })) || [])]
        },
        {
            key: 'tags',
            icon: CONFIG.ICONS.tag,
            label: 'Tags',
            options: [{ value: 'all', label: 'All' }, ...(tags?.map((t) => ({ value: t, label: t })) || [])]
        },
        {
            key: 'type',
            icon: CONFIG.ICONS.type,
            label: 'Type',
            options: TYPE_OPTIONS
        },
    ], [dropdownOptions, tags]);
    return (_jsx(DirectoryBase, { moduleKey: CONFIG.MODULE_KEY, pageTitle: "Partner Directory", addNewButtonLabel: "Add New Partner", uploadButtonLabel: "Upload Partner Contact", fetchThunk: fetchOpportunitiesThunk, deleteThunk: deleteOpportunityThunk, exportFn: exportPartnerDirectory, renderCell: renderCell, columns: COLUMNS, filtersConfig: filtersConfig, AddNewDrawer: AddNewPartnerDrawer, UploadDrawer: UploadDirectoryDrawer, selectors: useMemo(() => ({
            items: selectOpportunities,
            loading: selectOpportunityLoading,
            total: selectOpportunityTotal,
            lastUpdated: selectLastUpdated,
            tags: selectOpportunityTags,
        }), []) }));
};
export default PartnerDirectory;
